module.exports = __webpack_public_path__ + "static/red_icon-90516bc6199269a7e417f98ca8c18d67.png";